/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type KeywordCategory = {
    category: KeywordCategory.category;
    keywords: Array<string>;
};
export namespace KeywordCategory {
    export enum category {
        BRAND = 'brand',
        COMPETITORS = 'competitors',
        PRODUCT = 'product',
        INDUSTRY = 'industry',
        PEOPLE = 'people',
        SENTIMENT = 'sentiment',
        SUPPORT = 'support',
        PURCHASE = 'purchase',
        NEWS = 'news',
    }
}

